interface DetailStatusGroup {
  id: string;
  statuses: string[];
}

/**
 * Status groups for request details (individual monthly payments).
 * Similar structure to requestStatus.ts but without colors.
 */
const detailStatusGroups: DetailStatusGroup[] = [
  {
    id: 'PendingApproval',
    statuses: ['PendingInitialApproval', 'PendingExceptionsCommitteeApproval'],
  },
  {
    id: 'Approved',
    statuses: ['InitialApprovalApproved'],
  },
  {
    id: 'PendingExecution',
    statuses: ['PendingExecution'],
  },
  {
    id: 'InDocumentCompletion',
    statuses: ['PendingCompletion', 'CompletionReturned'],
  },
  {
    id: 'Done',
    statuses: ['Done'],
  },
  {
    id: 'Rejected',
    statuses: ['Rejected'],
  },
  {
    id: 'Cancelled',
    statuses: ['Cancelled'],
  },
  {
    id: 'PaymentReturned',
    statuses: ['PaymentReturned'],
  },
];

// Build reverse lookup map
const statusToGroupMap: Record<string, string> = {};
detailStatusGroups.forEach((group) => {
  group.statuses.forEach((status) => {
    statusToGroupMap[status] = group.id;
  });
});

/**
 * Gets the display ID for translation lookup.
 * @example getDetailStatusDisplayId('CompletionReturned') => 'PendingCompletion'
 */
export const getDetailStatusDisplayId = (status: string): string => {
  return statusToGroupMap[status] || status;
};
